/* eslint-disable */
import * as Types from '../graphql/types.generated';

import { gql } from '@apollo/client';
export type RichTextBlockEntry_Agent_Fragment = { __typename?: 'Agent', sys: { __typename?: 'Sys', id: string } };

export type RichTextBlockEntry_AgentBadge_Fragment = { __typename?: 'AgentBadge', sys: { __typename?: 'Sys', id: string } };

export type RichTextBlockEntry_Article_Fragment = { __typename?: 'Article', sys: { __typename?: 'Sys', id: string } };

export type RichTextBlockEntry_ArticleCategory_Fragment = { __typename?: 'ArticleCategory', sys: { __typename?: 'Sys', id: string } };

export type RichTextBlockEntry_City_Fragment = { __typename?: 'City', sys: { __typename?: 'Sys', id: string } };

export type RichTextBlockEntry_County_Fragment = { __typename?: 'County', sys: { __typename?: 'Sys', id: string } };

export type RichTextBlockEntry_Page_Fragment = { __typename?: 'Page', sys: { __typename?: 'Sys', id: string } };

export type RichTextBlockEntry_Plan_Fragment = { __typename?: 'Plan', sys: { __typename?: 'Sys', id: string } };

export type RichTextBlockEntry_Review_Fragment = { __typename?: 'Review', sys: { __typename?: 'Sys', id: string } };

export type RichTextBlockEntry_Snippet_Fragment = { __typename?: 'Snippet', sys: { __typename?: 'Sys', id: string } };

export type RichTextBlockEntry_SnippetGroup_Fragment = { __typename?: 'SnippetGroup', sys: { __typename?: 'Sys', id: string } };

export type RichTextBlockEntry_SnippetList_Fragment = { __typename?: 'SnippetList', key?: string | null, items?: Array<string | null> | null, sys: { __typename?: 'Sys', id: string } };

export type RichTextBlockEntryFragment = RichTextBlockEntry_Agent_Fragment | RichTextBlockEntry_AgentBadge_Fragment | RichTextBlockEntry_Article_Fragment | RichTextBlockEntry_ArticleCategory_Fragment | RichTextBlockEntry_City_Fragment | RichTextBlockEntry_County_Fragment | RichTextBlockEntry_Page_Fragment | RichTextBlockEntry_Plan_Fragment | RichTextBlockEntry_Review_Fragment | RichTextBlockEntry_Snippet_Fragment | RichTextBlockEntry_SnippetGroup_Fragment | RichTextBlockEntry_SnippetList_Fragment;

export type RichTextHyperlinkEntry_Agent_Fragment = { __typename?: 'Agent', slug?: string | null, sys: { __typename?: 'Sys', id: string } };

export type RichTextHyperlinkEntry_AgentBadge_Fragment = { __typename?: 'AgentBadge', sys: { __typename?: 'Sys', id: string } };

export type RichTextHyperlinkEntry_Article_Fragment = { __typename?: 'Article', slug?: string | null, sys: { __typename?: 'Sys', id: string } };

export type RichTextHyperlinkEntry_ArticleCategory_Fragment = { __typename?: 'ArticleCategory', sys: { __typename?: 'Sys', id: string } };

export type RichTextHyperlinkEntry_City_Fragment = { __typename?: 'City', sys: { __typename?: 'Sys', id: string } };

export type RichTextHyperlinkEntry_County_Fragment = { __typename?: 'County', sys: { __typename?: 'Sys', id: string } };

export type RichTextHyperlinkEntry_Page_Fragment = { __typename?: 'Page', slug?: string | null, sys: { __typename?: 'Sys', id: string } };

export type RichTextHyperlinkEntry_Plan_Fragment = { __typename?: 'Plan', sys: { __typename?: 'Sys', id: string } };

export type RichTextHyperlinkEntry_Review_Fragment = { __typename?: 'Review', sys: { __typename?: 'Sys', id: string } };

export type RichTextHyperlinkEntry_Snippet_Fragment = { __typename?: 'Snippet', sys: { __typename?: 'Sys', id: string } };

export type RichTextHyperlinkEntry_SnippetGroup_Fragment = { __typename?: 'SnippetGroup', sys: { __typename?: 'Sys', id: string } };

export type RichTextHyperlinkEntry_SnippetList_Fragment = { __typename?: 'SnippetList', sys: { __typename?: 'Sys', id: string } };

export type RichTextHyperlinkEntryFragment = RichTextHyperlinkEntry_Agent_Fragment | RichTextHyperlinkEntry_AgentBadge_Fragment | RichTextHyperlinkEntry_Article_Fragment | RichTextHyperlinkEntry_ArticleCategory_Fragment | RichTextHyperlinkEntry_City_Fragment | RichTextHyperlinkEntry_County_Fragment | RichTextHyperlinkEntry_Page_Fragment | RichTextHyperlinkEntry_Plan_Fragment | RichTextHyperlinkEntry_Review_Fragment | RichTextHyperlinkEntry_Snippet_Fragment | RichTextHyperlinkEntry_SnippetGroup_Fragment | RichTextHyperlinkEntry_SnippetList_Fragment;

export type RichTextBlockAssetFragment = { __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, sys: { __typename?: 'Sys', id: string } };

export const RichTextBlockEntryFragmentDoc = gql`
    fragment RichTextBlockEntry on Entry {
  sys {
    id
  }
  ... on SnippetList {
    key
    items
  }
}
    `;
export const RichTextHyperlinkEntryFragmentDoc = gql`
    fragment RichTextHyperlinkEntry on Entry {
  sys {
    id
  }
  ... on Article {
    slug
  }
  ... on Page {
    slug
  }
  ... on Agent {
    slug
  }
}
    `;
export const RichTextBlockAssetFragmentDoc = gql`
    fragment RichTextBlockAsset on Asset {
  sys {
    id
  }
  title
  url
  width
  height
}
    `;